import { HealthMarkerConversion } from '../types/HealthMarkerReport';
import { Units } from '../types/Units';

export function getUnit(selectedUnit: Units | undefined, markerConversion: HealthMarkerConversion | undefined) {
  if (selectedUnit == Units.Reference) {
    return markerConversion?.referenceUnit?.unit;
  } else if (selectedUnit == Units.Metric) {
    return markerConversion?.siUnit?.unit;
  } else if (selectedUnit == Units.Imperial) {
    return markerConversion?.usUnit?.unit;
  }

  return undefined;
}

export function getFactor(
  markerUnit: string,
  selectedUnit: Units | undefined,
  markerConversion: HealthMarkerConversion | undefined
) {
  let currentUnitType = markerConversion?.bloodworkUnitsTypes.find((unitType) => unitType.unit == markerUnit);
  let referenceUnitType = markerConversion?.bloodworkUnitsTypes.find(
    (unitType) => unitType.unit == markerConversion.referenceUnit.unit
  );

  if (selectedUnit == Units.Reference) {
    return currentUnitType && currentUnitType
      ? Number(currentUnitType?.conversionFactor) / Number(referenceUnitType?.conversionFactor)
      : 1;
  } else if (selectedUnit == Units.Metric && markerConversion?.siFactor != undefined) {
    let siUnitType = markerConversion?.bloodworkUnitsTypes.find(
      (unitType) => unitType.unit == markerConversion.siUnit?.unit
    );
    return currentUnitType && siUnitType
      ? Number(currentUnitType?.conversionFactor) / Number(siUnitType?.conversionFactor)
      : Number(markerConversion?.siFactor);
  } else if (
    selectedUnit == Units.Imperial &&
    markerConversion?.siFactor != undefined &&
    markerConversion?.usToSiFactor != undefined
  ) {
    let usUnitType = markerConversion?.bloodworkUnitsTypes.find(
      (unitType) => unitType.unit == markerConversion.usUnit?.unit
    );
    return usUnitType
      ? Number(currentUnitType?.conversionFactor) / Number(usUnitType?.conversionFactor)
      : Number(markerConversion?.siFactor) / Number(markerConversion?.usToSiFactor);
  }

  return 1;
}
